import { TAG } from '../../../../../../../constants/queryKeys';
import { useQuery } from '@tanstack/react-query';
import TagApiV2 from '../../../../../../../lib/api/tag/TagApiV2';

export const useRelatedTagList = (tagId: number) => {
  const { data } = useQuery(TAG.RELATED_TAG(tagId), () => TagApiV2.fetchRelateTagList(String(tagId)));

  return data?.tags;
};
